import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PdfViewerService {
  constructor(private http: HttpClient) {}

  private baseUrl: string = environment.API_SERVER;

  viewPdf(
    data: { documentPath: string; documentName: string },
    type?: string
  ): void {
    const fileExtension = this.getFileExtension(data.documentPath);

    let contentType = this.getContentType(fileExtension);

    const headers = new HttpHeaders({
      'Content-Type': contentType,
      'Content-Disposition': 'inline',
    });

    this.http
      .get(
        `${this.baseUrl}/public/${type ? type : 'media'}/?media=${
          data.documentPath
        }&file_name=${data.documentName}`,
        {
          headers: headers,
          responseType: 'arraybuffer',
        }
      )
      .subscribe((response) => {
        const blob = new Blob([response], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      });
  }

  viewImage(imagePath: string): void {
    const headers = new HttpHeaders({
      'Content-Type': 'image/*', // Specify content type for images
    });

    this.http
      .get(`${this.baseUrl}/public/images/?image=${imagePath}`, {
        headers: headers,
        responseType: 'arraybuffer',
      })
      .subscribe((response) => {
        const blob = new Blob([response], { type: 'image/*' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      });
  }

  private getFileExtension(filePath: string): string {
    return filePath.split('.').pop()?.toLowerCase() ?? '';
  }

  private getContentType(fileExtension: string): string {
    switch (fileExtension) {
      case 'pdf':
        return 'application/pdf';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'doc':
        return 'application/msword';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'gif':
        return 'image/gif';
      // Add more cases for other image types as needed
      default:
        return 'application/octet-stream'; // Default content type for unknown file types
    }
  }
}
